import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { ApiMutationTrackerService } from '../services/api-mutation-tracker.service';

const READ_METHODS = ['GET', 'HEAD', 'OPTIONS'];

/**
 * Endpoints that read through POST, because their filters travel in the body
 * (employee search, a calendar week...). Matched on the last path segment.
 * Counting them made opening the task dialog look like a save.
 */
const POST_READ_SEGMENTS = ['search', 'week', 'day', 'preview', 'capacity', 'month-availability', 'can-undo', 'can-redo'];

/** Feeds {@link ApiMutationTrackerService} with every successful write. */
export function apiMutationTrackerInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (READ_METHODS.includes(req.method)) return next(req);
  const path = req.url.split('?')[0].replace(/\/+$/, '');
  if (req.method === 'POST' && POST_READ_SEGMENTS.includes(path.slice(path.lastIndexOf('/') + 1))) return next(req);
  const tracker = inject(ApiMutationTrackerService);
  return next(req).pipe(
    tap((event) => {
      if (event instanceof HttpResponse && event.ok) tracker.record();
    }),
  );
}
